import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shouldFetchTeams"];
import I18n from 'I18n';
import { useCallback } from 'react';
import { HELPDESK } from '../../shared/constants/workspaces';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import AgentSelectItem from '../../users-and-teams/components/AgentSelectItem';
import UsersAndTeamsSelect from '../../users-and-teams/components/UsersAndTeamsSelect';
import { useShowFooter } from '../hooks/useShowFooter';
import { getUsersAndTeams } from '../operators/routingRulesGetters';
import ManageSeatsBanner from './ManageSeatsBanner';
import RoundRobinRowFetchTeams from './RoundRobinRowFetchTeams';
import { RoutingMethodTooltip } from './RoutingMethodTooltip';
import RuleBox from './RuleBox';
import UnassignedSeatsBanner from './UnassignedSeatsBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const renderFooter = (showFooter, showManageSeatsFooter, onClose) => {
  if (!showFooter) {
    return undefined;
  }
  return showManageSeatsFooter ? /*#__PURE__*/_jsx(ManageSeatsBanner, {
    onClose: onClose
  }) : /*#__PURE__*/_jsx(UnassignedSeatsBanner, {
    onClose: onClose
  });
};
const DeprecatedRoundRobinRow = ({
  routingRules,
  currentUser,
  disabled,
  FormControl,
  inboxId,
  isLoading,
  onUserOrTeamSelect = () => {},
  onUsersAndTeamsMount = () => {},
  teamsOptions,
  teamTree,
  userAndTeamSelectValueComponent,
  usersAndTeamsSelectError,
  usersOptions,
  trackUsage = () => {},
  showLabel = true,
  workSpace,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const {
    showFooter,
    dismissFooter
  } = useShowFooter(currentUser);
  const {
    teamIds,
    userIds
  } = getUsersAndTeams(routingRules);
  const isNewSeatingModel = isUngatedForHelpDeskRoutingScopeFiltering && workSpace === HELPDESK;
  const errorMessage = usersAndTeamsSelectError ? I18n.text('routing-ui.routingRules.roundRobin.selectUserOrTeam') : undefined;
  const ItemComponent = useCallback(props => /*#__PURE__*/_jsx(AgentSelectItem, Object.assign({
    isOptionItemInDropdown: true,
    isNewSeatingModel: isNewSeatingModel
  }, props)), [isNewSeatingModel]);
  return /*#__PURE__*/_jsx(TrackUsageContext.Provider, {
    value: trackUsage,
    children: /*#__PURE__*/_jsx(RuleBox, {
      FormControl: FormControl,
      showLabel: showLabel,
      tooltip: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
        routingRules: routingRules
      }),
      tooltipProps: {
        maxWidth: 271
      },
      children: /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
        "data-test-id": "round-robin-row-select",
        disabled: !!disabled,
        dropDownFooter: renderFooter(showFooter, isNewSeatingModel, dismissFooter),
        error: errorMessage,
        handleChange: onUserOrTeamSelect,
        hideUserSectionTooltip: isNewSeatingModel,
        inboxId: inboxId,
        isLoading: isLoading,
        itemComponent: ItemComponent,
        onMount: onUsersAndTeamsMount,
        selectedTeamIds: teamIds,
        selectedUserIds: userIds,
        teamsOptions: teamsOptions,
        teamTree: teamTree,
        usersOptions: usersOptions,
        valueComponent: userAndTeamSelectValueComponent
      })
    })
  });
};
DeprecatedRoundRobinRow.displayName = 'DeprecatedRoundRobinRow';
const checkHasObjectTypeId = props => !!props.objectTypeId && typeof props.objectTypeId === 'string';
const checkIsDeprecatedProps = props => props.shouldFetchTeams !== true && !checkHasObjectTypeId(props);

// this function is temporary to make TypeScript happy
const getRealProps = props => {
  const realProps = _objectWithoutPropertiesLoose(props, _excluded);
  return realProps;
};
const RoundRobinRow = props => {
  if (checkIsDeprecatedProps(props)) {
    return /*#__PURE__*/_jsx(DeprecatedRoundRobinRow, Object.assign({}, getRealProps(props)));
  }
  return /*#__PURE__*/_jsx(RoundRobinRowFetchTeams, Object.assign({}, getRealProps(props)));
};
RoundRobinRow.displayName = 'RoundRobinRow';
export default RoundRobinRow;